// REDUX TYPES
export type GoalState = {
  settingGoalsActive: boolean;
};

export enum GoalActions {
  SET_GOAL_ACTIVE = 'goal/set_goal_active',
}
